var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConseil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9327 9.86557C15.9349 9.86557 16.9146 10.1628 17.7479 10.7196C18.5812 11.2763 19.2307 12.0677 19.6142 12.9936C19.9977 13.9196 20.0981 14.9384 19.9026 15.9214C19.707 16.9043 19.2244 17.8072 18.5158 18.5159C17.8071 19.2245 16.9042 19.7071 15.9213 19.9026C14.9383 20.0982 13.9195 19.9978 12.9936 19.6143C12.0676 19.2308 11.2763 18.5813 10.7195 17.748C10.1627 16.9147 9.86548 15.935 9.86548 14.9328C9.86548 14.2674 9.99655 13.6084 10.2512 12.9936C10.5058 12.3789 10.8791 11.8203 11.3496 11.3497C12.2999 10.3994 13.5888 9.86557 14.9327 9.86557V9.86557Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9314 17.4643V14.9314",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9315 12.4492C14.8689 12.4492 14.8076 12.4677 14.7555 12.5025C14.7034 12.5374 14.6628 12.5868 14.6389 12.6447C14.6149 12.7026 14.6086 12.7663 14.6208 12.8277C14.6331 12.8892 14.6632 12.9456 14.7075 12.9899C14.7518 13.0343 14.8083 13.0644 14.8697 13.0766C14.9312 13.0889 14.9949 13.0826 15.0528 13.0586C15.1106 13.0346 15.1601 12.994 15.1949 12.9419C15.2297 12.8898 15.2483 12.8286 15.2483 12.7659C15.2483 12.6819 15.2149 12.6014 15.1555 12.5419C15.0961 12.4825 15.0156 12.4492 14.9315 12.4492V12.4492Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46949 9.24301C8.53043 8.41438 7.31959 7.95973 6.06722 7.96552C4.82636 7.95575 3.62505 8.40165 2.69107 9.21866C1.75709 10.0357 1.15537 11.167 1 12.3981",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06626 1C6.62988 1 7.18084 1.16713 7.64947 1.48026C8.1181 1.79339 8.48336 2.23846 8.69905 2.75917C8.91473 3.27989 8.97117 3.85287 8.86121 4.40566C8.75125 4.95845 8.47985 5.46622 8.08131 5.86475C7.68277 6.26329 7.175 6.5347 6.62221 6.64466C6.06942 6.75461 5.49644 6.69818 4.97572 6.48249C4.45501 6.26681 4.00994 5.90155 3.69682 5.43292C3.38369 4.96429 3.21655 4.41333 3.21655 3.84971C3.21655 3.09392 3.51679 2.36908 4.05121 1.83466C4.58564 1.30024 5.31047 1 6.06626 1V1Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2983 1C14.7366 1 15.1652 1.12999 15.5297 1.37354C15.8942 1.61709 16.1783 1.96326 16.346 2.36827C16.5138 2.77328 16.5577 3.21894 16.4722 3.64889C16.3866 4.07884 16.1755 4.47378 15.8656 4.78376C15.5556 5.09374 15.1606 5.30484 14.7307 5.39036C14.3007 5.47589 13.8551 5.43199 13.4501 5.26423C13.045 5.09647 12.6989 4.81238 12.4553 4.44789C12.2118 4.08339 12.0818 3.65485 12.0818 3.21648C12.0817 2.92539 12.139 2.63715 12.2504 2.36821C12.3618 2.09928 12.525 1.85492 12.7309 1.64909C12.9367 1.44326 13.1811 1.28 13.45 1.16863C13.7189 1.05725 14.0072 0.999955 14.2983 1V1Z",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5909 7.96589C17.2885 7.44295 16.8657 6.99964 16.3577 6.67272C15.8498 6.3458 15.2711 6.14471 14.6699 6.0861C14.0687 6.0275 13.4621 6.11308 12.9006 6.33574C12.339 6.55841 11.8386 6.91174 11.4409 7.36644",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConseil);
export default __webpack_public_path__ + "static/media/Conseil.f681c6bfc05ec0ec3fa1e5e7a2f1820d.svg";
export { ForwardRef as ReactComponent };